import React from "react";
import cjbairport from "../src/images/parking.webp";
import parkingimage from "../src/images/parkingimg.webp";
import lostandfound from "../src/images/lostandfound.webp";
import bustaxitrain from "../src/images/bustaxitrain.webp";
import foodloungerestaurant from "../src/images/food.webp";
import hotels from "../src/images/hotels.webp";
import { NavLink } from "react-router-dom";
import airport from "../src/images/logo.png";
// import wave1 from "../src/images/wave1.webp";
// import video1 from "../src/images/video.mp4";
import airlines from "../src/images/airlines.webp";
import Records from './Records.json'
import { TbPlaneTilt } from "react-icons/tb";
import {Helmet} from 'react-helmet-async';

const Home = () => {
  return (
    <>
    <Helmet>
      <title>Home</title>
      <meta name='description' content="Coimbatore Airport All Services"/>
      <link rel="canonical" href="/"/>
    </Helmet>
    <section id="banner">
      <div className="container ">
        <div className="row">
          <div className="col-md-6 ">
          
            <h1 className="promo-title"><strong>{Records.airportName}</strong> <TbPlaneTilt/><br/><br/> {Records.airportOperator} </h1>
            
            
          </div>
          <div className="col-md-6 text-center">
            <img src={airport} className="img-fluid " alt="airport"/>
          </div>
        </div>
      </div>
{/* <img src={wave1} className="bottom-img" alt="wave"/> */}


    </section>
    <br/>
      <section id="header">
        <div className="container-fluid nav_bg">
          <div className="row">
            <div className="col-12 mx-auto">
              <div className="row">
                <div className="col-lg-6 order-1 order-lg-2 header-img">
                  <img
                    src={cjbairport}
                    className="img-fluid animated"
                    alt="Coimbatore International Airport"
                  />
                </div>
                <div className="col-md-6 pt-3 pt-lg-0 order-2 order-lg-1">
                  <h4>
                    <strong>MBB Airport</strong> is located
                    in Agratala city in
                    <strong>Tripura state of India.</strong>
                  </h4>
                  <h5 className="my-3">
                    Agratala Airport is located, 12 km (7
                    miles) from Agartala city.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-5">
          <h1 className="text-center">Services</h1>
          <div className="container-fluid mb-5">
            <div className="row">
              <div className="col-10 mx-auto">
                <div className="row gy-4">
                  <div className="col-md-4 col-10 mx-auto">


                    <div className="card">
                      <img src={lostandfound} className="card-img-top img-thumbnail img-responsive" alt="lost and found" />
                      <div className="card-body">
                        <h5 className="card-title">Lost & Found Items</h5>
                        <p className="card-text">
                          For Information about Lost and Found Items
                        </p>
                        <NavLink to="/lostandfound" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>
                    

                    <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={parkingimage} className="card-img-top img-thumbnail img-responsive" alt="parking" />
                      <div className="card-body">
                        <h5 className="card-title">Vehicle Parking</h5>
                        <p className="card-text">
                          For Information about Vehicle Parking
                        </p>
                        <NavLink to="/parking" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                      <br/>

                      <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={bustaxitrain} className="card-img-top img-thumbnail img-responsive" alt="bus taxi train" />
                      <div className="card-body">
                        <h5 className="card-title">Bus/Taxi/Train</h5>
                        <p className="card-text">
                        For Information about Bus / Taxi / Train
                        </p>
                        <NavLink to="/transport" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>

                    <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={foodloungerestaurant} className="card-img-top img-thumbnail img-responsive" alt="food lounge restaurant" />
                      <div className="card-body">
                        <h5 className="card-title">Food Restaurant and Lounges</h5>
                        <p className="card-text">
                        For Information about Food, Lounges and Restaurant
                        </p>
                        <NavLink to="/restaurant" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>

                    <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={hotels} className="card-img-top img-thumbnail img-responsive" alt="Hotels" />
                      <div className="card-body">
                        <h5 className="card-title">Nearby Hotels</h5>
                        <p className="card-text">
                        For Information about nearby Hotels.
                        </p>
                        <NavLink to="/hotels" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>


                    <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={airlines} className="card-img-top img-thumbnail img-responsive" alt="Airlines Arrival and Departure" />
                      <div className="card-body">
                        <h5 className="card-title">Flight Information</h5>
                        <p className="card-text">
                        Arrival and Departure Flights
                        </p>
                        <NavLink to="/airlines" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>

                    
                    
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
